import { HistoryItem } from './types';
import React from 'react';
import { Box, Flex, Text } from 'rebass';
import FilePreviews from '../File/FilePreviews';
import TimelineStatusComment from './TimelineStatusComment';
import IconLink from '../Icon/IconLink';
import Icon from '@/components/Icon/Icon';

export type TimelineItemProps = HistoryItem & {
  noRail?: boolean;
  isInitial?: boolean;
  isFirst?: boolean;
  isLast?: boolean;
  isFinal?: boolean;
  children?: React.ReactNode;
  footer?: string;
};

const TimelineItem = (props: TimelineItemProps) => {
  const {
    noRail = false,
    footer,
    children,
    isInitial = false,
    isFirst = false,
    isLast = false,
    type,
    icon,
    iconColor = '#000',
    title,
    comment,
    adornment,
    isFinal,
    url,
    thumb,
    contentType,
  } = props;

  return (
    <Flex flexDirection="column" alignItems="stretch">
      <Box flexGrow="1">
        {type === 'ATTACHMENT' && url && contentType && (
          <FilePreviews
            files={[
              {
                url,
                contentType,
                thumb: thumb ?? null,
              },
            ]}
          />
        )}

        {title && (
          <Flex alignItems="center" sx={{ gap: '2px' }}>
            {!noRail && !!icon && (
              <Box
                width={['10px', '10px', '10px', '20px']}
                display={['none', 'none', 'none', 'flex']}
                alignItems={'center'}
                flexDirection={'column'}
                flexShrink={0}
                className={isFinal ? 'history-rail is-final' : 'history-rail'} // use these to hook onto
              >
                <Flex
                  p="4px"
                  alignItems={'center'}
                  justifyContent={'center'}
                  sx={{
                    background: iconColor,
                    position: 'relative',
                    borderRadius: '50%',
                    '*': {
                      display: ['none', 'none', 'none', 'block'],
                    },
                  }}
                >
                  <Icon icon={icon} color="white" size="10px" />
                </Flex>
              </Box>
            )}
            {url ? (
              <IconLink
                iconAtEnd
                iconSize={3}
                isPrimary
                color="inherit"
                lineHeight="12px"
                fontSize="12px"
                fontWeight="bold"
                href={url}
                m={0}
                p={0}
                sx={{
                  display: 'block',
                  textDecoration: 'none',
                  ':hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                {title}
              </IconLink>
            ) : (
              <Text
                fontFamily="root"
                lineHeight="12px"
                fontSize="12px"
                fontWeight="bold"
              >
                {title}
              </Text>
            )}
          </Flex>
        )}

        {comment && (
          <TimelineStatusComment mt={title ? 1 : undefined} comment={comment} />
        )}

        {children}

        {/* Meta */}
        {footer && (
          <Flex
            alignSelf="flex-end"
            alignItems="center"
            ml={3}
            mt="3px"
            sx={{ gap: 1 }}
          >
            <Text fontStyle="italic" fontSize="12px" lineHeight="12px">
              {footer}
            </Text>
            {adornment}
          </Flex>
        )}
      </Box>
    </Flex>
  );
};

export default TimelineItem;
